export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const PUSH_PREVIOUS_NOTIFICATION = "PUSH_PREVIOUS_NOTIFICATION";
export const SET_NOTIFICATIONS_COUNT = "SET_NOTIFICATIONS_COUNT";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
